import BaseObject from '../../base/base_object';
import {IGeoBase} from "./geo_service_interface";
import GeoLocationService from "./geo_service";
import {GEO_LOCATION} from "./geo_consts";

export interface IGeoParams {
    waitTimeOut:string;
    platform:string;
}


export default class GeoBase extends BaseObject implements IGeoBase{

    static CLASS = 'GeoBase';
    protected parent:GeoLocationService = null;
    protected initParams:IGeoParams;

    protected init(params:IGeoParams) : void {
        super.init(params);
        this.initParams = params;
    }
    public runWrapper():void{};

    public setParent(parent):void {
        this.parent = parent;
    }

    public isPlugInEnable(bMandatory):Promise<boolean> {
        return Promise.resolve(true);
    }

    public getGeoLocation(data):Promise<void> {
        //should be overridden
        return Promise.resolve();
    }

    protected sendAnalytics(action:string, additionalData:any=null):void {

        let analyticsData:any = {
            category: GEO_LOCATION.GA_GEO_LOCATION_CATEGORY_WRAPPER + ' ' + this.constructor.name,
            action: action
        };
        if (additionalData){
            analyticsData.geoData = additionalData;
        }
        this.logger.info(action, JSON.stringify(analyticsData));
        this.parent.getServiceFactory().structuredLoggingService().getLogger(analyticsData).info();
    }
}